import HtmlContent from "./modules/html-content";
import TitleBanner from "./title-banner";

export default function PageContent({ page }) {
  return (
    <>
      {page.title.rendered && (
        <TitleBanner
          title={page.title.rendered}
          location={page.type === "vacancy" && page.extra_fields.location}
          hours_per_week={
            page.type === "vacancy" && page.extra_fields.hours_per_week
          }
          cssClasses="pb-50"
        />
      )}
      <div className="rounded-edge-shape rounded-edge-shape--up--white" />
      <section className="pt-75 pb-75">
        <div className="container">
          <div className="frame frame--justify-md-center">
            <div className="bit-xxs-12 bit-md-10 bit-lg-9">
              {page.content.rendered && page.content.rendered.length && (
                <HtmlContent content={page.content.rendered} />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
